<template>
  <div id="app" class="w-screen">
    <MobileHeader
      v-if="isMobile && canshowBanner"
      :isMenuVisible="isMenuVisible"
      @setIsMenuVisible="handleSetIsMenuVisible"
    />
    <div :class="isMobile?'bannerMobile':''" v-if="!$route.meta.isBanner&&!isMenuVisible&&isMobile" style="position: relative">
      <img
        src="@/assets/list/banner.png"
        style="width: 100%;height: 100%"
        alt=""
      />
      </div>
    <router-view v-show="!isMenuVisible"/>
  </div>

</template>
<script>
import Header from "@/views/Header.vue";
// import { debounce } from "lodash";
import { mapGetters } from "vuex";
import MobileHeader from "@/views/Mobile/components/MobileHeader.vue";

export default {
  components: {
    Header,
    MobileHeader,
  },
  data() {
    return {
      isMenuVisible: false, // 是否展示菜单
      // 防抖函数
      debounceCheckIsMobile: () => {},
      navList:[],
      screenWidth: null,
    };
  },
  methods: {
    // 设定是否展示菜单
    handleSetIsMenuVisible(visible) {
      this.isMenuVisible = visible;
    },
  },
  computed: {
    ...mapGetters(["isMobile"]),
    canshowBanner(){// 不是预约实验室相关页面时显示banner
      return this.$route.path !== '/applySelect' && 
        this.$route.path !== '/myApply' && 
        this.$route.path !== '/reservation' && 
        this.$route.path !== '/collegeList' && 
        this.$route.path !== '/labList'
    }
  },
  created() {
    // // 监听屏幕宽度变化防抖函数
    // this.debounceCheckIsMobile = debounce(() => {
    //   this.$store.commit("setIsMobile", {
    //     isMobile: window.screen?.availWidth <= 980,
    //   });
    // }, 100);
    // // 加载时执行一次
    // this.debounceCheckIsMobile();
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    // 根据屏幕宽度变化动态切换组件
    // window.addEventListener("resize", this.debounceCheckIsMobile);

    this.$store.dispatch("getLoginStatus");
  },
watch:{

  screenWidth: {
    handler: function (val) {
      if (val < 1080) {
        // console.log(val+'屏幕宽度小于980px')
        this.$store.commit("setIsMobile", {
          isMobile: true,
        });
      } else {
        // console.log(val+'屏幕宽度大于980px')
        this.$store.commit("setIsMobile", {
          isMobile: false,
        });

      }
    },
    immediate: true,
    deep:true
  },
},
  // 组件销毁前移除事件监听
  destroyed() {
    // window.removeEventListener("resize", this.debounceCheckIsMobile);
    // this.debounceCheckIsMobile.cancel();
  },
};
</script>

<style>
body,
html {
  height: 100%;
}

#app {
  height: 100%;
  overflow-y: auto;
  position: relative;
}
.bannerMobile{
  width: 100%;
  height: 150px;
  /* height: 150px;
  background: url("~@/assets/list/banner.png") no-repeat;
  background-size: 100% 100%; */
  object-fit: contain;
}

/* .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
} */

</style>
